import { Controller } from "@hotwired/stimulus"

// Alpine keeps an x-show element's visibility in its `style` and drops its
// `x-cloak` once it starts. A morph refresh would put back the server's
// attributes and snap open toggles shut, so while this page is up those stay
// as Alpine left them.
export default class extends Controller {
  initialize() {
    this.keepAlpineVisibility = this.keepAlpineVisibility.bind(this)
  }

  connect() {
    document.addEventListener("turbo:before-morph-attribute", this.keepAlpineVisibility)
  }

  disconnect() {
    document.removeEventListener("turbo:before-morph-attribute", this.keepAlpineVisibility)
  }

  keepAlpineVisibility(event) {
    if (!event.target.hasAttribute("x-show")) return

    if ([ "style", "x-cloak" ].includes(event.detail.attributeName)) event.preventDefault()
  }
}
